// Counts practice time while the video plays or the mic is listening.

const TICK_SECONDS = 5;

export default function practiceTimerPlugin(store) {
  setInterval(() => {
    try {
      const player = store.state.player;
      const recognition = store.state.recognition;

      const videoPlaying = !!(player && player.playerInstance && player.playerState === 1);
      const listening = !!(recognition && recognition.speakingMode && recognition.micActive);

      if (videoPlaying || listening) {
        store.dispatch('stats/addPracticeTime', TICK_SECONDS);
      }
    } catch (e) { /* never break the app from a timer */ }
  }, TICK_SECONDS * 1000);

  store.dispatch('stats/refreshStats');
}
